import { Helmet } from 'react-helmet-async';
import { Box } from '@mui/material';

import EditorialHeader from '../components/editorial/EditorialHeader';
import CinematicHero from '../components/editorial/CinematicHero';
import LifeAtKBT from '../components/editorial/LifeAtKBT';
import LetterFromTheRabbi from '../components/editorial/LetterFromTheRabbi';
import ScheduleAtAGlance from '../components/editorial/ScheduleAtAGlance';
import FeaturedFlyers from '../components/editorial/FeaturedFlyers';
import DuskInvitation from '../components/editorial/DuskInvitation';
import EditorialFooter from '../components/editorial/EditorialFooter';

// ----------------------------------------------------------------------
// KBT Landing — "Editorial Sanctum"
// Composition:
//   1) Cinematic Hero
//   2) Pinned Almanac (daily-rhythm crossfade)
//   3) Letter from the Rabbi
//   4) Schedule at a Glance  ← full weekly schedule
//   5) Featured Flyers       ← 3 real upcoming events (replaces the
//                              old "week, read aloud" panel)
//   6) Dusk Invitation       ← donate
//   7) Footer
// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  return (
    <>
      <Helmet>
        <title>KBT  ·  A House of Study & Prayer</title>
        <meta
          name="description"
          content="KBT — Kehilat Bnei Torah, Los Angeles. More than just a Beit Knesset. Daily prayer, weekly study, open doors."
        />
      </Helmet>

      {/* film grain overlay (fixed; ignores pointer events) */}
      <div className="editorial-grain" aria-hidden />

      <Box
        sx={{
          background: 'var(--paper)',
          color: 'var(--text)',
        }}
      >
        <EditorialHeader />
        <CinematicHero />
        <LifeAtKBT />
        <LetterFromTheRabbi />
        <ScheduleAtAGlance />
        <FeaturedFlyers />
        <DuskInvitation />
        <EditorialFooter />
      </Box>
    </>
  );
}
